// RoofTiles recipe — Buildings Set1 §7.4: barrel-tile ridging (`waves` along one axis +
// domainRepeat). Uses the new `barrelTiles` primitive (composes waves + domainRepeatAxis).
// Immutable built-in root.
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const ROOF_TILES_RECIPE_ID = "roofTiles";

export const roofTilesRecipe = new MaterialRecipe({
	id: ROOF_TILES_RECIPE_ID,
	name: "Roof tiles",
	roughness: 0.55,
	specStrength: 0.08,

	params: [
		new ParamSchema({key: "tile_width", label: "Tile width (m)", kind: "scalar", min: 0.05, max: 0.5, default: 0.15}),
		new ParamSchema({key: "tile_length", label: "Tile length (m)", kind: "scalar", min: 0.05, max: 1, default: 0.3}),
		new ParamSchema({key: "crest_height", label: "Crest height (m)", kind: "scalar", min: 0, max: 0.05, default: 0.012}),
		new ParamSchema({key: "tile_ramp", label: "Tile ramp", kind: "ramp", default: [0, 0.6, 0.42, 0.3, 0.5, 0.72, 0.52, 0.36, 1, 0.5, 0.34, 0.24]}),
		new ParamSchema({key: "gap_color", label: "Gap colour", kind: "color", default: [0.2, 0.16, 0.12]}),
	],
	layers: [
		new MaterialLayer({
			id: "barrels",
			primitive: "barrelTiles",
			args: {
				tileWidth: {ref: "tile_width"},
				tileLength: {ref: "tile_length"},
				crestHeight: {ref: "crest_height"},
				tileRamp: {ref: "tile_ramp"},
				gapColor: {ref: "gap_color"},
			},
			blend: "over",
			contributes: "both",
		}),
	],
});
